/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<rect
				opacity="0.4"
				x="2"
				y="14"
				width="12"
				height="8"
				rx="2"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="8"
				rx="2"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="2"
				y="2"
				width="20"
				height="8"
				rx="2"
				fill="currentColor"
			/>
			<path
				d="M2 5.2C2 4.07989 2 3.51984 2.21799 3.09202C2.40973 2.71569 2.71569 2.40973 3.09202 2.21799C3.51984 2 4.07989 2 5.2 2H18.8C19.9201 2 20.4802 2 20.908 2.21799C21.2843 2.40973 21.5903 2.71569 21.782 3.09202C22 3.51984 22 4.07989 22 5.2V6.8C22 7.92011 22 8.48016 21.782 8.90798C21.5903 9.28431 21.2843 9.59027 20.908 9.78201C20.4802 10 19.9201 10 18.8 10H5.2C4.0799 10 3.51984 10 3.09202 9.78201C2.71569 9.59027 2.40973 9.28431 2.21799 8.90798C2 8.48016 2 7.92011 2 6.8V5.2Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 17.2C2 16.0799 2 15.5198 2.21799 15.092C2.40973 14.7157 2.71569 14.4097 3.09202 14.218C3.51984 14 4.0799 14 5.2 14H10.8C11.9201 14 12.4802 14 12.908 14.218C13.2843 14.4097 13.5903 14.7157 13.782 15.092C14 15.5198 14 16.0799 14 17.2V18.8C14 19.9201 14 20.4802 13.782 20.908C13.5903 21.2843 13.2843 21.5903 12.908 21.782C12.4802 22 11.9201 22 10.8 22H5.2C4.07989 22 3.51984 22 3.09202 21.782C2.71569 21.5903 2.40973 21.2843 2.21799 20.908C2 20.4802 2 19.9201 2 18.8V17.2Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M1.25 5.25C1.25 3.84987 1.25 3.1498 1.52248 2.61502C1.76217 2.14462 2.14462 1.76217 2.61502 1.52248C3.1498 1.25 3.84987 1.25 5.25 1.25H18.75C20.1501 1.25 20.8502 1.25 21.385 1.52248C21.8554 1.76217 22.2378 2.14462 22.4775 2.61502C22.75 3.1498 22.75 3.84987 22.75 5.25V6.75C22.75 8.15013 22.75 8.8502 22.4775 9.38498C22.2378 9.85538 21.8554 10.2378 21.385 10.4775C20.8502 10.75 20.1501 10.75 18.75 10.75H5.25C3.84987 10.75 3.1498 10.75 2.61502 10.4775C2.14462 10.2378 1.76217 9.85538 1.52248 9.38498C1.25 8.8502 1.25 8.15013 1.25 6.75V5.25Z"
				fill="currentColor"
			/>
			<path
				d="M5.25 13.25C3.84987 13.25 3.1498 13.25 2.61502 13.5225C2.14462 13.7622 1.76217 14.1446 1.52248 14.615C1.25 15.1498 1.25 15.8499 1.25 17.25V18.75C1.25 20.1501 1.25 20.8502 1.52248 21.385C1.76217 21.8554 2.14462 22.2378 2.61502 22.4775C3.1498 22.75 3.84987 22.75 5.25 22.75H10.75C12.1501 22.75 12.8502 22.75 13.385 22.4775C13.8554 22.2378 14.2378 21.8554 14.4775 21.385C14.75 20.8502 14.75 20.1501 14.75 18.75V17.25C14.75 15.8499 14.75 15.1498 14.4775 14.615C14.2378 14.1446 13.8554 13.7622 13.385 13.5225C12.8502 13.25 12.1501 13.25 10.75 13.25H5.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M14 2H18.8C19.9201 2 20.4802 2 20.908 2.21799C21.2843 2.40973 21.5903 2.71569 21.782 3.09202C22 3.51984 22 4.0799 22 5.2V6.8C22 7.92011 22 8.48016 21.782 8.90798C21.5903 9.28431 21.2843 9.59027 20.908 9.78201C20.4802 10 19.9201 10 18.8 10L5.2 10C4.0799 10 3.51984 10 3.09202 9.78201C2.71569 9.59027 2.40973 9.28431 2.21799 8.90798C2 8.48016 2 7.92011 2 6.8V5.2C2 4.07989 2 3.51984 2.21799 3.09202C2.40973 2.71569 2.71569 2.40973 3.09202 2.21799C3.51984 2 4.07989 2 5.2 2H10M5.2 22H10.8C11.9201 22 12.4802 22 12.908 21.782C13.2843 21.5903 13.5903 21.2843 13.782 20.908C14 20.4802 14 19.9201 14 18.8V17.2C14 16.0799 14 15.5199 13.782 15.092C13.5903 14.7157 13.2843 14.4097 12.908 14.218C12.4802 14 11.9201 14 10.8 14H5.20001C4.0799 14 3.51985 14 3.09202 14.218C2.7157 14.4097 2.40974 14.7157 2.21799 15.092C2.00001 15.5199 2.00001 16.0799 2.00001 17.2V18.8C2.00001 19.9201 2.00001 20.4802 2.21799 20.908C2.40974 21.2843 2.7157 21.5903 3.09202 21.782C3.51985 22 4.0799 22 5.2 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M2 5.2C2 4.07989 2 3.51984 2.21799 3.09202C2.40973 2.71569 2.71569 2.40973 3.09202 2.21799C3.51984 2 4.07989 2 5.2 2H18.8C19.9201 2 20.4802 2 20.908 2.21799C21.2843 2.40973 21.5903 2.71569 21.782 3.09202C22 3.51984 22 4.07989 22 5.2V6.8C22 7.92011 22 8.48016 21.782 8.90798C21.5903 9.28431 21.2843 9.59027 20.908 9.78201C20.4802 10 19.9201 10 18.8 10H5.2C4.0799 10 3.51984 10 3.09202 9.78201C2.71569 9.59027 2.40973 9.28431 2.21799 8.90798C2 8.48016 2 7.92011 2 6.8V5.2Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 17.2C2 16.0799 2 15.5198 2.21799 15.092C2.40973 14.7157 2.71569 14.4097 3.09202 14.218C3.51984 14 4.0799 14 5.2 14H10.8C11.9201 14 12.4802 14 12.908 14.218C13.2843 14.4097 13.5903 14.7157 13.782 15.092C14 15.5198 14 16.0799 14 17.2V18.8C14 19.9201 14 20.4802 13.782 20.908C13.5903 21.2843 13.2843 21.5903 12.908 21.782C12.4802 22 11.9201 22 10.8 22H5.2C4.07989 22 3.51984 22 3.09202 21.782C2.71569 21.5903 2.40973 21.2843 2.21799 20.908C2 20.4802 2 19.9201 2 18.8V17.2Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M5.25 13.25C3.84987 13.25 3.1498 13.25 2.61502 13.5225C2.14462 13.7622 1.76217 14.1446 1.52248 14.615C1.25 15.1498 1.25 15.8499 1.25 17.25V18.75C1.25 20.1501 1.25 20.8502 1.52248 21.385C1.76217 21.8554 2.14462 22.2378 2.61502 22.4775C3.1498 22.75 3.84987 22.75 5.25 22.75H10.75C12.1501 22.75 12.8502 22.75 13.385 22.4775C13.8554 22.2378 14.2378 21.8554 14.4775 21.385C14.75 20.8502 14.75 20.1501 14.75 18.75V17.25C14.75 15.8499 14.75 15.1498 14.4775 14.615C14.2378 14.1446 13.8554 13.7622 13.385 13.5225C12.8502 13.25 12.1501 13.25 10.75 13.25H5.25Z"
				fill="currentColor"
			/>
			<path
				d="M1.25 5.25C1.25 3.84987 1.25 3.1498 1.52248 2.61502C1.76217 2.14462 2.14462 1.76217 2.61502 1.52248C3.1498 1.25 3.84987 1.25 5.25 1.25H18.75C20.1501 1.25 20.8502 1.25 21.385 1.52248C21.8554 1.76217 22.2378 2.14462 22.4775 2.61502C22.75 3.1498 22.75 3.84987 22.75 5.25V6.75C22.75 8.15013 22.75 8.8502 22.4775 9.38498C22.2378 9.85538 21.8554 10.2378 21.385 10.4775C20.8502 10.75 20.1501 10.75 18.75 10.75H5.25C3.84987 10.75 3.1498 10.75 2.61502 10.4775C2.14462 10.2378 1.76217 9.85538 1.52248 9.38498C1.25 8.8502 1.25 8.15013 1.25 6.75V5.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
